import { tss } from 'tss-react/mui';

// Color constants
const COLORS = {
  PRIMARY_BLUE: "#1064B2",
  ERROR: "error",
  PRIMARY: "primary",
  BLACK: "#000000",
  WHITE_TRANSPARENT: "rgba(255,255,255,0.5)",
} as const;

const useStyles = tss.withParams().create(({ theme }) => ({
  // Existing error page styles
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: COLORS.WHITE_TRANSPARENT,
    width: '100%',
    flexDirection: 'column',
    height: '100vh',
  },
  errorTitle: {
    fontSize: '200px',
    fontWeight: 300,
    color: COLORS.BLACK,
    [theme.breakpoints.down('sm')]: {
      fontSize: '100px',
    },
  },
  errorMessage: {
    fontSize: '32px',
    fontWeight: 300,
    color: COLORS.BLACK,
    lineHeight: '44px',
    textAlign: 'center',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      lineHeight: '20px',
    },
  },
  
  // Home component styles
  appBar: {
    backgroundColor: COLORS.PRIMARY_BLUE,
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: theme.spacing(8),
  },
  formContainer: {
    width: "80%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      width: "95%",
    },
  },
  textField: {
    marginBottom: theme.spacing(2),
    width: "300px",
    [theme.breakpoints.down('sm')]: {
      width: "100%",
    },
  },
  selectContainer: {
    textAlign: "left",
    width: "300px",
    [theme.breakpoints.down('sm')]: {
      width: "100%",
    },
  },
  select: {
    marginTop: theme.spacing(2),
  },
  errorText: {
    marginTop: theme.spacing(0.375),
    marginLeft: theme.spacing(1.875),
    fontSize: "13px",
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1),
      fontSize: "12px",
    },
  },
  button: {
    marginTop: theme.spacing(3),
    width: "auto",
    minWidth: "120px",
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      maxWidth: "300px",
    },
  },
  appBarTitle: {
    flexGrow: 1,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
  },
}));

export default useStyles;